// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3Z1lX","header":"MessagesList_header__TB4XI","chat":"MessagesList_chat__XgzPu"};